// extracted by mini-css-extract-plugin
export default {"container":"BlocksContainer_container__-N8pz"};